import { siteApi } from '../admin/siteApi';

export const moderationCommand = async (text) => {
  const tokens = text.trim().match(/"[^"]+"|\S+/g) || [];
  const command = tokens.shift()?.slice(1).toLowerCase();
  if (!['timeout', 'untimeout', 'ban', 'unban'].includes(command)) return false;
  const username = tokens.shift()?.replace(/^@/, '').replace(/^"(.*)"$/, '$1');
  if (!username) throw new Error(`Enter a username after /${command}.`);
  let duration;
  if (tokens[0] && (/^\d/.test(tokens[0]) || ['perm', 'permanent'].includes(tokens[0].toLowerCase()))) duration = tokens.shift();
  await siteApi('/chat/moderation/commands', { method: 'POST', body: JSON.stringify({ request_id: crypto.randomUUID(), command, username, duration, reason: tokens.join(' ') }) });
  return true;
};